// Namensraum "admin": Verwaltungsseiten (Benutzer, Rollen, Arbeitszeitmodelle, Team, Teams)
const admin = {
  'admin.common.save': 'Speichern',
  'admin.common.cancel': 'Abbrechen',
  'admin.common.edit': 'Bearbeiten',
  'admin.common.delete': 'Löschen',
  'admin.common.error': 'Fehler',
  'admin.common.none': '–',

  'admin.users.title': 'Benutzerverwaltung',
  'admin.users.new': 'Neuer Benutzer',
  'admin.users.edit': 'Benutzer bearbeiten',
  'admin.users.personnelNumber': 'Personalnummer *',
  'admin.users.password': 'Passwort',
  'admin.users.passwordKeep': '(leer = unverändert)',
  'admin.users.firstName': 'Vorname *',
  'admin.users.lastName': 'Nachname *',
  'admin.users.email': 'E-Mail',
  'admin.users.role': 'Rolle',
  'admin.users.noRole': '– Keine Rolle –',
  'admin.users.supervisor': 'Vorgesetzter',
  'admin.users.noSupervisor': '– Kein Vorgesetzter –',
  'admin.users.weeklyHours': 'Wochenarbeitszeit (Std.)',
  'admin.users.vacationDays': 'Urlaubstage pro Jahr',
  'admin.users.entryDate': 'Eintrittsdatum',
  'admin.users.col.nr': 'Nr.',
  'admin.users.col.name': 'Name',
  'admin.users.col.email': 'E-Mail',
  'admin.users.col.role': 'Rolle',
  'admin.users.col.supervisor': 'Vorgesetzter',
  'admin.users.col.status': 'Status',
  'admin.users.col.created': 'Erstellt',
  'admin.users.col.actions': 'Aktionen',
  'admin.users.active': 'Aktiv',
  'admin.users.inactive': 'Inaktiv',
  'admin.users.deactivate': 'Deaktivieren',
  'admin.users.activate': 'Aktivieren',
  'admin.users.confirmDelete': 'Benutzer wirklich löschen?',

  'admin.roles.title': 'Rollen & Berechtigungen',
  'admin.roles.roles': 'Rollen',
  'admin.roles.new': 'Neue Rolle',
  'admin.roles.edit': 'Rolle bearbeiten',
  'admin.roles.name': 'Name *',
  'admin.roles.description': 'Beschreibung',
  'admin.roles.permissions': 'Berechtigungen:',
  'admin.roles.confirmDelete': 'Rolle wirklich löschen?',
  'admin.roles.permissionsTitle': 'Berechtigungen',
  'admin.roles.newPermission': 'Neue Berechtigung',
  'admin.roles.code': 'Code (eindeutig) *',
  'admin.roles.create': 'Erstellen',
  'admin.roles.confirmDeletePermission': 'Berechtigung wirklich löschen?',

  'admin.schedules.title': 'Arbeitszeitmodelle',
  'admin.schedules.new': 'Neues Modell',
  'admin.schedules.edit': 'Modell bearbeiten',
  'admin.schedules.newTitle': 'Neues Arbeitszeitmodell',
  'admin.schedules.name': 'Name *',
  'admin.schedules.type': 'Typ',
  'admin.schedules.typeFixedLong': 'Festarbeitszeit',
  'admin.schedules.typeFlex': 'Gleitzeit',
  'admin.schedules.typeFixedShort': 'Festzeit',
  'admin.schedules.employee': 'Mitarbeiter (leer = Standard)',
  'admin.schedules.defaultAll': 'Standard (alle)',
  'admin.schedules.workStart': 'Arbeitsbeginn',
  'admin.schedules.workEnd': 'Arbeitsende',
  'admin.schedules.dailyHours': 'Tägliche Sollstunden',
  'admin.schedules.dayHoursTitle': 'Sollstunden je Wochentag (optional)',
  'admin.schedules.dayHoursHint': 'Leer = tägliche Sollstunden × Arbeitstage. 0 = freier Tag.',
  'admin.schedules.weekTotal': 'Wochensoll: {hours}h',
  'admin.schedules.dayHoursLabel': 'Wochentage:',
  'admin.schedules.daysPerWeek': 'Arbeitstage / Woche',
  'admin.schedules.autoBreakAfter': 'Auto-Pause nach (Stunden)',
  'admin.schedules.autoBreakAfterPlaceholder': 'z.B. 6',
  'admin.schedules.autoBreakDuration': 'Auto-Pause Dauer (Minuten)',
  'admin.schedules.autoBreakDurationPlaceholder': 'z.B. 30',
  'admin.schedules.setDefault': 'Als Standard setzen',
  'admin.schedules.default': 'Standard',
  'admin.schedules.typeLabel': 'Typ:',
  'admin.schedules.employeeLabel': 'Mitarbeiter:',
  'admin.schedules.targetLabel': 'Sollzeit:',
  'admin.schedules.targetValue': '{hours}h / Tag · {days} Tage/Wo.',
  'admin.schedules.timesLabel': 'Zeiten:',
  'admin.schedules.autoBreakLabel': 'Auto-Pause:',
  'admin.schedules.autoBreakValue': 'nach {hours}h → {minutes} min',
  'admin.schedules.empty': 'Keine Arbeitszeitmodelle vorhanden.',
  'admin.schedules.confirmDelete': 'Arbeitszeitmodell löschen?',
  'admin.schedules.unknownUser': 'User #{id}',

  'admin.team.title': 'Team-Übersicht',
  'admin.team.refreshHint': 'Aktualisiert jede Minute',
  'admin.team.total': 'Mitarbeiter gesamt',
  'admin.team.checkedIn': 'Eingestempelt',
  'admin.team.notPresent': 'Nicht anwesend',
  'admin.team.filterAll': 'Alle',
  'admin.team.filterIn': 'Anwesend',
  'admin.team.filterOut': 'Abwesend',
  'admin.team.homeOffice': 'Homeoffice',
  'admin.team.office': 'Büro',
  'admin.team.absent': 'Abwesend',
  'admin.team.pdfTitle': 'Monatsbericht {month} {year} herunterladen',
  'admin.team.empty': 'Keine Mitarbeiter gefunden.',
  'admin.team.reportFile': 'Monatsbericht',

  'admin.teams.title': 'Teams',
  'admin.teams.newTitle': 'Neues Team anlegen',
  'admin.teams.name': 'Teamname',
  'admin.teams.description': 'Beschreibung (optional)',
  'admin.teams.substituteRequired': 'Vertretung bei Urlaubsanträgen erforderlich',
  'admin.teams.substituteRequiredHint': 'Mitglieder müssen bei Urlaubsanträgen eine Vertretung aus dem Team wählen.',
  'admin.teams.create': 'Anlegen',
  'admin.teams.empty': 'Keine Teams vorhanden',
  'admin.teams.noMembers': 'Keine Mitglieder',
  'admin.teams.deleteTitle': 'Team löschen',
  'admin.teams.removeTitle': 'Aus Team entfernen',
  'admin.teams.addEmployee': 'Mitarbeiter hinzufügen…',
  'admin.teams.add': 'Hinzufügen',
  'admin.teams.confirmDelete': 'Team „{name}“ wirklich löschen?',
  'admin.teams.actionFailed': 'Aktion fehlgeschlagen',

  'admin.overview.title': 'Administration',
  'admin.overview.subtitle': 'Zentrale Übersicht aller Verwaltungsbereiche',
  'admin.overview.open': 'Öffnen',
  'admin.overview.users.title': 'Benutzer',
  'admin.overview.users.desc': 'Benutzerkonten anlegen und verwalten',
  'admin.overview.roles.title': 'Rollen',
  'admin.overview.roles.desc': 'Rollen und Berechtigungen festlegen',
  'admin.overview.schedules.title': 'Arbeitszeitmodelle',
  'admin.overview.schedules.desc': 'Arbeitszeitmodelle pflegen',
  'admin.overview.team.title': 'Team',
  'admin.overview.team.desc': 'Zeiten und Status des Teams einsehen',
  'admin.overview.teams.title': 'Teams',
  'admin.overview.teams.desc': 'Teams anlegen und Mitglieder zuordnen',
    'admin.userDetail.title': 'Benutzerdetails',
    'admin.userDetail.open': 'Details',
    'admin.userDetail.back': 'Zurück zur Benutzerliste',
    'admin.userDetail.notFound': 'Benutzer konnte nicht geladen werden',
    'admin.userDetail.master': 'Stammdaten',
    'admin.userDetail.year': 'Jahr',
    'admin.userDetail.times': 'Zeiteinträge',
    'admin.userDetail.timesTotal': 'Gesamt: {hours} Std.',
    'admin.userDetail.noTimes': 'Keine Zeiteinträge',
    'admin.userDetail.col.date': 'Datum',
    'admin.userDetail.col.checkIn': 'Kommen',
    'admin.userDetail.col.checkOut': 'Gehen',
    'admin.userDetail.col.break': 'Pause (Min.)',
    'admin.userDetail.col.worked': 'Arbeitszeit',
    'admin.userDetail.vacation': 'Urlaub',
    'admin.userDetail.noVacation': 'Keine Urlaubsanträge',
    'admin.userDetail.vacationStatus.PENDING': 'Offen',
    'admin.userDetail.vacationStatus.APPROVED': 'Genehmigt',
    'admin.userDetail.vacationStatus.REJECTED': 'Abgelehnt',
    'admin.userDetail.absences': 'Abwesenheiten',
    'admin.userDetail.absencesAdd': 'Abwesenheit eintragen',
    'admin.userDetail.absencesEdit': 'Abwesenheit bearbeiten',
    'admin.userDetail.noAbsences': 'Keine Abwesenheiten',
    'admin.userDetail.noAbsencePermission': 'Für Abwesenheiten ist die Berechtigung "manage_absences" erforderlich.',
  };

export default admin;

